module.exports = __webpack_public_path__ + "5c5e2c8f86f3a503d113c03bf42b99b9.png";